import { useSettings } from '@/composables/settings/useSettings';
import { computed } from 'vue';
import { Setting } from '@/constants/settings';

/**
 * Get which currency should be displayed for current user.
 * In case DISPLAY_CURRENCY is not set, we use fallbacks.
 */
export const useDisplayCurrency = () => {
	const { setting, loading } = useSettings();

	return computed(() => {
		if (loading.value) {
			return undefined;
		}

		return (
			setting(Setting.DISPLAY_CURRENCY) ||
			setting(Setting.DEFAULT_CURRENCY) ||
			setting(Setting.BASE_CURRENCY) ||
			undefined
		);
	});
};
